import {
  connectionStateChanged,
  sessionEnded,
  sessionListeners,
  sessionReactions,
  sessionSongChanged,
  sessionVerseChanged,
} from "../actions/sessionActions";
import {
  queueCleared,
  queueReordered,
  queueSongAdded,
  queueSongRemoved,
  queueSongSung,
  queueSongTranspose,
} from "../actions/queueActions";
import { librarySongAdded, librarySongRemoved } from "../actions/libraryActions";
import { songDeleted } from "../actions/catalogActions";
import { requestAdded, requestRemoved } from "../actions/requestsActions";

// Older API versions sent JSON strings; the current one sends objects.
const parse = (message) => (typeof message === "string" ? JSON.parse(message) : message);

/** Registers every server-push handler once, for the lifetime of the app. */
export function registerSocketListeners(socket, dispatch) {
  socket.onStateChange((state) => dispatch(connectionStateChanged(state)));

  socket.on("UpdateSongId", (message) => {
    const { SongId, VerseNum } = parse(message);
    dispatch(sessionSongChanged(SongId, VerseNum));
  });

  socket.on("UpdateVerseNum", (message) => {
    dispatch(sessionVerseChanged(parse(message).VerseNum));
  });

  socket.on("AddSongToQueue", (message) => {
    dispatch(queueSongAdded(parse(message)));
  });

  socket.on("RemoveSongFromQueue", (message) => {
    dispatch(queueSongRemoved(parse(message).SongId));
  });

  socket.on("QueueReordered", (message) => {
    dispatch(queueReordered(parse(message).SongIds));
  });

  socket.on("QueueSongSung", (message) => {
    const { SongId, Sung } = parse(message);
    dispatch(queueSongSung(SongId, Sung));
  });

  socket.on("QueueSongTranspose", (message) => {
    const { SongId, Transpose } = parse(message);
    dispatch(queueSongTranspose(SongId, Transpose));
  });

  socket.on("SongDeleted", (message) => {
    dispatch(songDeleted(parse(message).SongId));
  });

  socket.on("QueueCleared", () => {
    dispatch(queueCleared());
  });

  socket.on("SessionEnded", (message) => {
    dispatch(sessionEnded(parse(message).Code));
  });

  socket.on("AddSongToLibrary", (message) => {
    const song = parse(message);
    if (song) dispatch(librarySongAdded(song));
  });

  socket.on("RemoveSongFromLibrary", (message) => {
    dispatch(librarySongRemoved(parse(message).SongId));
  });

  socket.on("Reaction", (message) => {
    dispatch(sessionReactions(parse(message).Reactions));
  });

  socket.on("Listeners", (message) => {
    dispatch(sessionListeners(parse(message).Count));
  });

  socket.on("SongRequested", (message) => {
    const request = parse(message);
    if (request) dispatch(requestAdded(request));
  });

  socket.on("RequestRemoved", (message) => {
    dispatch(requestRemoved(parse(message).RequestId));
  });
}
